'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/SureDesignSystem/Accordion/AccordionItem.js';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AccordionModule = require('./Accordion.module.css');

var _AccordionModule2 = _interopRequireDefault(_AccordionModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  item: _propTypes2.default.shape({
    id: _propTypes2.default.number,
    title: _propTypes2.default.string,
    description: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
  }).isRequired,
  onToggle: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  isOpen: _propTypes2.default.bool
};
var defaultProps = {
  className: null,
  isOpen: false
};

var AccordionItem = function (_PureComponent) {
  _inherits(AccordionItem, _PureComponent);

  function AccordionItem(props) {
    _classCallCheck(this, AccordionItem);

    var _this = _possibleConstructorReturn(this, (AccordionItem.__proto__ || Object.getPrototypeOf(AccordionItem)).call(this, props));

    _this.state = {
      bodyHeight: 0
    };
    return _this;
  }

  _createClass(AccordionItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.setState({
          bodyHeight: this.itemBody.scrollHeight
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isOpen !== this.props.isOpen) {
        if (this.props.isOpen) {
          this.setState({
            bodyHeight: this.itemBody.scrollHeight
          });
        } else {
          this.setState({
            bodyHeight: 0
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          item = _props.item,
          onToggle = _props.onToggle,
          isOpen = _props.isOpen,
          className = _props.className;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_AccordionModule2.default.itemWrapper, className),
        onClick: function onClick() {
          return onToggle(item);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56
        },
        __self: this
      }, _react2.default.createElement('div', {
        className: _AccordionModule2.default.itemHeader,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60
        },
        __self: this
      }, _react2.default.createElement('h3', {
        className: _AccordionModule2.default.itemTitle,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61
        },
        __self: this
      }, item.title), _react2.default.createElement('div', {
        className: _AccordionModule2.default.itemToggleWrapper,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        },
        __self: this
      }, _react2.default.createElement('i', {
        className: (0, _classnames2.default)('fal', {
          'fa-plus': !isOpen,
          'fa-minus': isOpen
        }, _AccordionModule2.default.itemToggleIcon),
        onClick: function onClick() {
          return onToggle(item);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63
        },
        __self: this
      }))), _react2.default.createElement('div', {
        className: _AccordionModule2.default.itemBody,
        ref: function ref(c) {
          return _this2.itemBody = c;
        },
        style: {
          height: this.state.bodyHeight + 'px'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77
        },
        __self: this
      }, _react2.default.createElement('div', {
        className: _AccordionModule2.default.itemDescription,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82
        },
        __self: this
      }, item.description)));
    }
  }]);

  return AccordionItem;
}(_react.PureComponent);

AccordionItem.propTypes = propTypes;
AccordionItem.defaultProps = defaultProps;
exports.default = AccordionItem;